import { Typography } from "@mui/material";
import { ReactComponent as SuccessImage } from "../../../assets/img/fermier-success.svg";

const StepCompleted = () => {
  return (
    <div className="text-center flex flex-col items-center">
      <Typography color={"primary"} fontSize={24} mb={2}>
        Félicitations !
      </Typography>
      <Typography fontSize={18}>
        Votre compte a été créé avec succès.
      </Typography>

      <div className="flex w-full justify-center py-8">
        <SuccessImage />
      </div>

      <Typography fontSize={14} className="max-w-[230px] w-full mt-4">
        Ajoutez au moins une Champs à votre compte pour finaliser votre
        inscription.
      </Typography>
    </div>
  );
};

export default StepCompleted;
